import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import commonServices from './commonServices';
import contractServices from 'components/Contracts/contractServices';
import WizardServices from 'components/wizard/WizardServices';
import DeleteDialogueBox from './deleteDialogue';
import Pagination from 'components/Common/newPagination';

export function RegionForm(param: any) {

    let [isOpen, setIsOpen] = React.useState(false);
    let [AllRegions, setAllRegions] = useState<any>([]);
    let [AllRegionsBtn, setAllRegionsBtn] = useState(false);
    let [territoryBtn, setterritoryBtn] = useState(false);
    let [territoryGroup, setterritoryGroup] = useState<any>([]);
    let [regionTerritories, setregionTerritories] = useState<any>([]);


    const toggleDrawer = () => { setIsOpen((prevState) => !prevState) }
    const AllRegionsData = () => {
        setAllRegionsBtn(!AllRegionsBtn);
        commonServices.AllRegions().then((res) => {
            AllRegions = res;
            setAllRegions(AllRegions);
        })
    }


    let [selectedRegion, setselectedRegion] = useState<any>([]);
    let [allTerritory, setallTerritory] = useState<any>([]);
    let [tempTerritory, settempTerritory] = useState<any>([]);

    var pagination = { pageNumber: 1, pageSize: 10 }

    const setRegionDesc = (e: any) => {
        console.log(param)
        selectedRegion = e;
        setselectedRegion(selectedRegion)
        setterritoryBtn(!territoryBtn);
        setterritoryGroup({ ...territoryGroup, groupDesc: e.groupDesc })
        setAllRegionsBtn(!AllRegionsBtn);
        commonServices.systemTerritoryCode({ regionCode: e.groupingId }).then((res) => {
            regionTerritories = res
            setregionTerritories(regionTerritories);
            contractServices.territoryCode().then((res) => {
                allTerritory = res
                setallTerritory(allTerritory)
                tempTerritory = res?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
                settempTerritory(tempTerritory)
            })
        })
    }
    const AvailableTerritoriesPagination = (e: any) => {
        pagination.pageNumber = e.pageNumber
        pagination.pageSize = e.pageSize

        tempTerritory = allTerritory?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        settempTerritory(tempTerritory);
    }

    let [territoriesDBError, setterritoriesDBError] = useState(false);
    let [territoriesError, setterritoriesError] = useState(false);

    const fillRegionTerritorries = () => {

        var payload = []
        payload.push(regionTerritories)
        payload.push(selectedTerritory)

        const flatData = payload.flat();

        setregionTerritories(flatData)

    }

    let [selectedTerritory, setSelectedTerritory] = useState<any>([]);
    const selectTerritory = (territory: any) => {
        console.log(selectedTerritory)

        if (!checkTerritory(territory)) {

            selectedTerritory.push(territory);
            setSelectedTerritory(selectedTerritory)
        } else {
            setSelectedTerritory(
                selectedTerritory.filter((t: any) => t.territoryName !== territory.territoryName)
            );
        }

        tempTerritory = allTerritory?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        settempTerritory(tempTerritory)
    }


    const checkTerritory = (territory: any) => {
        var status = false

        /*console.log(status)
        console.log(territory)
        console.log(selectedTerritory)
        console.log(selectedTerritory?.filter((e: any) => e.territoryName == territory.territoryName)?.length)*/

        status = selectedTerritory?.filter((e: any) => e.territoryName == territory.territoryName)?.length > 0 ? true : false;
        return status
    }

    const resetData = () => {
        selectedRegion = [];
        setselectedRegion(selectedRegion);

        territoryGroup = [];
        setterritoryGroup(territoryGroup);

        allTerritory = [];
        setallTerritory(allTerritory);

        tempTerritory = [];
        settempTerritory(tempTerritory);

        regionTerritories = [];
        setregionTerritories(regionTerritories);
    }

    const saveRegion = () => {
        console.log(selectedRegion)
        console.log(regionTerritories)
        var territoryCodeList = []
        for (var i = 0; i < regionTerritories.length; i++) {
            territoryCodeList.push({ territoryCode: regionTerritories[i]?.territoryCode, territoryName: regionTerritories[i]?.territoryName })
        }

        var payload = {
            groupingId: selectedRegion?.groupId,
            territoryCodes: territoryCodeList
        }

        WizardServices.TerritorySave(payload)
    }

    const clearTerritoriesInRegion = () => {
        WizardServices.clearTerritoriesInRegion({ groupingId: selectedRegion?.groupId })
    }

    let [message, setMessage] = useState("");
    let [deleteType, setDeleteType] = useState("");
    let [description, setDescription] = useState("");

    let [deleteData, setDeleteData] = useState<any>([]);
    let [deleteStatus, setDeleteStatus] = useState(false);


    const deleteTerritoryRegion = (type: any, data: any) => {

        console.log(type)
        console.log(data)
        deleteType = type
        setDeleteType(deleteType)
        deleteData = data
        setDeleteData(deleteData)
        deleteStatus = true;
        setDeleteStatus(deleteStatus)

        if (type == "removeTerritory") {
            message = "unlink the associated territory";
            setMessage(message);
        }

        if (type == "applyChanges") {
            description = "This operation will clear all regions on the RatesBasis, Adjustment, Reserves and Reducing Royalties assigned to this contract which are no longer being used. "
            setDescription(description);
            message = "proceed";
            setMessage(message);
        }

        if (type == "UnlinkedTerritories") {
            message = "unlink all associated territories for this region";
            setMessage(message);
        }


    }

    const deleteConfirmation = (e: any) => {
        console.log(e)

        //e==1 YES
        console.log(deleteData)
        if (e == 1) {
            //uploadDelete();
            if (deleteType == "removeTerritory") {
                WizardServices.deletesystemTerritory(deleteData)
            }

            if (deleteType == "applyChanges") {
                saveRegion();

                var payload = {
                    basis: "",
                    contractRefNum: param?.param?.contractRefNum,
                    defaultTerritory: "",
                    groupDesc: selectedRegion?.groupDesc,
                    groupingId: selectedRegion?.groupId,
                    territoryCode: "",
                    territoryName: ""
                }

                WizardServices.updateContractRegion(payload)

            }

            if (deleteType == "UnlinkedTerritories") {
                clearTerritoriesInRegion();
            }

        }
        //e==2 NO
        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    }

    return (
        <>
            <button className="icon-btn edit height35" type="button" onClick={() => { setIsOpen(true); resetData(); }}>
                Region
            </button>

            <Drawer open={isOpen} onClose={toggleDrawer} direction='right' className='react-drawer ' size={900}>


                <div className='box ws-8 pull-right'>

                    <div className="box-header">
                        <h2 className="ws-12">Add Region</h2>
                    </div>

                    <div className="box-content">

                        <div className="form-format ws-12">

                            <div className="ws-5">
                                <label className="control-label ">Region code*</label>
                                <div className="label-entries">
                                    <input type="text" name="groupingId" className="hide" ng-model="territoryGroup.groupingId" id="contractStatus.key" />
                                    <div className="label-entries regions-controls ">
                                        <div className="ws-10">
                                            <input type="text" name="groupingId" id="groupingId" disabled={selectedRegion?.groupingId} value={selectedRegion?.groupingId ?? ""} />
                                        </div>

                                        <div className="ws-2">
                                            <button type="button" className="icon-btn edit width50 height35" id="loadAllRegions" onClick={() => { AllRegionsData(); }}>
                                                {!AllRegionsBtn && <i className="icon-arrow-down m0"></i>}
                                                {AllRegionsBtn && <i className="icon-arrow-up m0"></i>}
                                            </button>
                                        </div>

                                        {AllRegionsBtn && <ul className="exisitingRegionsList">
                                            {
                                                AllRegions.map((data: any) => {
                                                    return (
                                                        <li onClick={() => setRegionDesc(data)}> {data.groupingId} : {data.groupDesc}</li>
                                                    )
                                                })
                                            }
                                        </ul>}

                                        <input type="hidden" data-ng-model="editRegionGroupId" />
                                    </div>
                                </div>
                            </div>

                            <div className="ws-6">

                                <label className="control-label ">Region description*</label>
                                <div className="label-entries">
                                    <input type="text" name="groupDesc" value={territoryGroup.groupDesc ?? ""} id="groupDesc" placeholder="Region description" />

                                </div>
                            </div>
                        </div>

                        {<div className="ws-12 pm">
                            {territoriesDBError && <div className="alert alert-danger" ng-show="territoriesDBError">No territories exist in the database</div>}
                            {territoriesError && <div className="alert alert-danger" data-ng-show="territoriesError">Please select some territories to associate to the region.  </div>}

                            {(selectedRegion?.groupingId) && <div className="ws-12">

                                {(regionTerritories.length > 0) && <>
                                    <div className="ws-5 pm">
                                        <h3 className="mb">Territories</h3>

                                        <div className='ws-12 forceSingleLine'>
                                            <span className='text-m text-bold pull-left ws-12 m0 pb'>Linked to region</span>
                                            <button className="icon-btn edit m0" onClick={() => deleteTerritoryRegion("applyChanges", {})}> Apply Changes to Contract</button>
                                            <button className="icon-btn info" onClick={() => deleteTerritoryRegion("UnlinkedTerritories", {})}> Unlinked All Territories</button>
                                        </div>

                                        <div className="form-format">
                                            <div className="label-entries">
                                                <input type="text" data-ng-model="linkToRegionSearch" placeholder="Search" />
                                            </div>
                                        </div>

                                        {(regionTerritories.length == 0) && <div className="alert alert-info " >Empty</div>}

                                        {(regionTerritories.length > 0) && <table className="newTable">
                                            <tbody>
                                                {
                                                    regionTerritories.map((res: any) => {
                                                        return (
                                                            <tr>
                                                                <td width="15%"> <a className="icon-btn delete" onClick={() => deleteTerritoryRegion('removeTerritory', res)}><i className="icon-trashcan"></i></a></td>
                                                                <td >{res.territoryName} </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>}

                                    </div>
                                </>}

                                <div className="ws-7 pm">
                                    <div className="ws-2">

                                        <button className="icon-btn edit pull-left" onClick={fillRegionTerritorries}>
                                            <i className="icon-arrow-left m0"></i>
                                        </button>
                                    </div>

                                    <div className='ws-12'>

                                        <h5>Available territories</h5>
                                        {(allTerritory.length > 0) && <div className="form-format">
                                            <div className="label-entries">
                                                <input type="text" placeholder="Search" />
                                            </div>
                                        </div>}

                                        {(allTerritory.length > 0) && <table className="newTable">
                                            <thead>
                                                <tr className='hide'>
                                                    <th style={{ width: "9%" }}>
                                                        <input type="checkbox" data-ng-change="selectAllTerritories()" data-ng-model="allTerritories.chkFlag" />
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {
                                                    tempTerritory?.map((value: any) => {
                                                        return (
                                                            <tr>
                                                                <td> <input type="checkbox" onClick={() => selectTerritory(value)} checked={checkTerritory(value)} /> </td>
                                                                <td >{value.territoryName}</td>
                                                                <td >{value.territoryCode}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>}

                                        {
                                            (() => {
                                                if (allTerritory.length && allTerritory.length > 10) {
                                                    return <Pagination onPageChange={AvailableTerritoriesPagination} totalRow={allTerritory.length} />
                                                }
                                            })()
                                        }

                                    </div>
                                </div>
                            </div>}

                        </div>}

                    </div>

                    <div className="clearfix mb mr pull-right pm">
                        <button className="icon-btn delete width90 height35" onClick={() => { setIsOpen(false); }}> Close </button>
                        <button className="icon-btn edit width90 height35" onClick={saveRegion}> Save </button>
                        <button className="icon-btn delete width90 height35"><i className="icon-reload"></i> Reset</button>
                    </div>

                    {
                        (() => {

                            if (deleteStatus) {
                                return <DeleteDialogueBox param={deleteStatus} description={description} message={message} onChange={deleteConfirmation} />
                            }
                        })()
                    }

                </div>
            </Drawer>
        </>
    );

}